import React, { useEffect, useState } from "react";
import axios from "axios";
import { NewsPaperPopUp } from "./newsPapeperPopUp";
import { currencyFormat } from "../utilities/utils";
import { PreLoader } from "../preLoader/preLoader";

export default function NewsPaperComponent({
  newspaperPrice,
  setNewspaperPrice,
  discount,
  setDiscount,
  priceAfterDiscount,
  setPriceAfterDiscount,
  setPublishID,
  categoryID,
  horizontal,
  vertical,
  paperType,
  sectorType,
}) {
  const [dataFromApi, setData] = useState({});
  const [visible, setVisible] = useState(false);
  const [more, setMore] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let url = window.location.origin;
    setIsLoading(true);
    axios({
      method: "get", //here erquest is sent
      url: `${url}/publishes_list?category_id=${categoryID}&horizontal=${horizontal}&vertical=${vertical}&sector_type=${sectorType}&paper_type=${paperType}`,
    }).then((response) => {
      setData(response.data);
      setIsLoading(false);
    });
  }, []);

  const handleRadioClick = (newspaperType, index, publishType) => {
    let detail = dataFromApi[newspaperType][index].details;
    setMore(detail);
    setNewspaperPrice(detail.actual_price);
    setDiscount(detail.discount_price);
    setPriceAfterDiscount(detail.publish_price);
    setPublishID(publishType.pid);
  };

  const transformedData = Object.keys(dataFromApi).map((paper) => {
    return {
      paper,
      paperData: [...dataFromApi[paper]],
    };
  });

  const sortData = (arr = transformedData, param = "Black/White") => {
    const sorted = [...arr];
    sorted.sort((a, b) => {
      const log = {
        a: 0,
        b: 0,
      };
      a.paperData.forEach((item) => {
        if (item.color_type === param && log.a - Number(item.price) < 0) {
          log.a = Number(item.price);
        }
      });
      b.paperData.forEach((item) => {
        if (item.color_type === param && log.b - Number(item.price) < 0) {
          log.b = Number(item.price);
        }
      });

      return log.a - log.b;
    });
    return sorted;
  };

  const openModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  return (
    <>
      {isLoading ? (
        <PreLoader />
      ) : (
        <div className="news-paper">
          {sortData().map((item, index) => {
            return (
              <div className="news-paper-section" key={index}>
                <div className="news-paper-image">
                  <img src={item.paperData[0].image.url} />
                </div>
                <div className="news-paper-block">
                  <p className="name content">{item.paper}</p>
                  <div className="news-paper-content-block">
                    {item.paperData
                      .sort((a, b) => a.price - b.price)
                      .map((publishType, index) => {
                        return (
                          <div key={index}>
                            <div className="news-paper-contet">
                              <input
                                type="radio"
                                value={publishType.pid}
                                name="radioVal"
                                className="radio"
                                data-value={publishType.price}
                                onClick={() =>
                                  handleRadioClick(
                                    item.paper,
                                    index,
                                    publishType
                                  )
                                }
                              />
                              <label
                                htmlFor="color-price"
                                className="small-content "
                              >
                                {publishType.color_type}
                              </label>
                              -
                              <label
                                htmlFor="color-price"
                                className="small-content price"
                              >
                                Rs.{currencyFormat(publishType.price)}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <button className="small-btn" onClick={() => openModal()}>
                    Price details
                  </button>

                  {visible && (
                    <NewsPaperPopUp
                      closeModal={closeModal}
                      visible={visible}
                      more={more}
                    />
                  )}
                </div>
              </div>
            );
          })}

          {/* <div className="new-paper-bottom">
        <div className="content-block">
          <p className="first-content">Price:</p>
          <p className="second-content">{newspaperPrice}</p>
        </div>
        <div className="content-block">
          <p className="first-content">Discount:</p>
          <p className="second-content">{discount}</p>
        </div>
        <div className="content-block">
          <p className="first-content">Total:</p>
          <p className="second-content">{priceAfterDiscount}</p>
        </div>
      </div> */}
        </div>
      )}
    </>
  );
}
